<template>
  <header class="page-header" role="banner">
    <div class="hidden-md-down position-relative">
      <a
        aria-label="Pokaż/ukryj menu"
        href="javascript:void(0)"
        title="Hide Navigation"
        class="header-btn btn js-waves-off cursor-pointer"
        @click="toggleNavigationState"
      >
        <i class="ni ni-menu" />
      </a>
    </div>

    <div class="hidden-lg-up">
      <a
        aria-label="Pokaż/ukryj menu"
        class="header-btn btn press-scale-down"
        href="javascript:void(0)"
        @click="toggleMobile"
      >
        <i class="ni ni-menu" />
      </a>
    </div>

    <div v-if="!!title" class="d-flex my-auto">
      <div class="header-icon d-flex align-items-center justify-content-center ml-2">
        <h1 class="mb-0">
          {{ title }}
        </h1>
      </div>
    </div>

    <div class="ml-auto d-flex">
      <check-permission permissions="MESSAGE.LIST" entity-type="profile" :entity-id="profileId">
        <div class="position-relative">
          <span v-if="messageCount > 0" class="counter my-2 position-absolute badge badge-secondary">
            {{ messageCount }}
          </span>

          <a
            aria-label="Pokaż powiadomienia"
            class="header-icon d-flex align-items-center justify-content-center ml-2 cursor-pointer"
            href="javascript:void(0)"
            @click="openMessages"
          >
            <i class="fal fa-fw fa-bell" />
          </a>

          <messages v-if="showMessages" class="position-absolute" @close="closeMessages" />
        </div>
      </check-permission>

      <div>
        <a
          v-if="isSsoUser"
          aria-label="Wyloguj się"
          class="header-icon d-flex align-items-center justify-content-center ml-2 cursor-pointer"
          :href="ssoLogoutUrl"
        >
          <i class="fal fa-sign-out-alt text-danger" />
        </a>

        <a
          v-else
          aria-label="Wyloguj się"
          class="header-icon d-flex align-items-center justify-content-center ml-2 cursor-pointer"
          href="javascript:void(0)"
          @click="logout"
        >
          <i class="fal fa-sign-out-alt text-danger" />
        </a>
      </div>
    </div>

    <div v-if="showMessages" class="messages-overlay" @click="closeMessages" />
  </header>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { mapState } from 'vuex';

import { config } from '@/utils/config';
import { getProfileId } from '@/utils/profile';
import Messages from '../messages/List';

// @vuese
// Nagłówek
// @group AppLayout
export default {
  name: 'Header',
  components: { Messages },
  data() {
    return {
      showMessages: false,
      intervalId: null,
      ssoLogoutUrl: config.ssoLogoutURL
    };
  },
  computed: {
    title() {
      if (this.$route.meta && this.$route.meta && this.$route.meta.title) {
        return this.$route.meta.title;
      }
      return '';
    },
    bodyElement() {
      return document.body;
    },
    profileId() {
      return getProfileId();
    },
    ...mapState({
      mobile: state => state.mobile.mobileNav,
      messageCount: state => state.systemMessage.unreadCount,
      isSsoUser: state => state.auth.token && !jwtDecode(state.auth.token).user.login.includes('@')
    })
  },
  watch: {
    mobile(to) {
      if (to) {
        this.bodyElement.classList.add('mobile-nav-on');
      } else {
        this.bodyElement.classList.remove('mobile-nav-on');
      }
    }
  },
  created() {
    this.$store.dispatch('setMobileNav', this.bodyElement.classList.contains('mobile-nav-on'));
  },
  mounted() {
    if (this.$store.state.auth.checkPermission.permissions[`MESSAGE.LIST:profile:${this.profileId}`]) {
      this.intervalId = setInterval(this.reloadList, 60000);
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    // @vuese
    // Wylogowanie
    logout() {
      this.$store.dispatch('setConfirm', {
        title: 'Wylogowanie',
        description: 'Czy jesteś pewien, że chcesz się wylogować?',
        onSuccess: () => {
          this.$store.dispatch('auth/logout');
          this.$router.push({ name: 'login' });
        }
      });
    },

    // @vuese
    // Pokazanie do sekcji powiadomień
    openMessages() {
      this.showMessages = true;
    },

    // @vuese
    // Zamyka powiadomienia
    closeMessages() {
      this.showMessages = false;
    },

    // @vuese
    // Chowa menu
    toggleNavigationState() {
      this.bodyElement.classList.toggle('nav-function-hidden');
    },

    // @vuese
    // Ustawia widok mobilny
    toggleMobile() {
      this.$store.dispatch('setMobileNav');
    },

    // @vuese
    // Przeładowanie listy nieprzeczytanych powiadomień
    reloadList() {
      this.$store.dispatch('systemMessage/unreadList', true);
    }
  }
};
</script>

<style>
.counter {
  top: 0;
  right: 0;
}
.messages-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 5;
}
</style>
